import React from 'react';
import { useTranslation } from './TranslationContext';
import '../styles/footer.css';
import '../styles/root.css';
import linkedin from '../assets/social/linkedin.png';
import instagram from '../assets/social/instagram.png';
import x from '../assets/social/x.png';
import youtube from '../assets/social/youtube.png';

const Footer = () => {
  const { translate } = useTranslation();
  const footer = translate('footer');

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section brand-section">
          <h2>{footer.brand}</h2>
          <p>{footer.tagline}</p>
        </div>
        <div className="footer-grid">
          <div className="footer-section">
            <h3>{footer.navigation.title}</h3>
            <ul className="footer-links">
              <li><a href="/savoirfaire">{footer.navigation.expertise}</a></li>
              <li><a href="/newsletter">{footer.navigation.newsletter}</a></li>
              <li><a href="/legalmentions">{footer.navigation.legalmentions}</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>{footer.contact.title}</h3>
            <ul className="footer-links">
              <li><a href="mailto:minaze.mg@gmail.com">{footer.contact.email}</a></li>
              <li><a href="tel:+33751272623">{footer.contact.phone}</a></li>
              <li><a href="/contact">{footer.contact.appointment}</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>{footer.social.title}</h3>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/alexandre-dutartre/">
                <img src={linkedin} alt="LinkedIn" />
              </a>
              <a href="#">
                <img src={instagram} alt="Instagram" />
              </a>
              <a href="#">
                <img src={x} alt="X" />
              </a>
              <a href="#">
                <img src={youtube} alt="YouTube" />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>{footer.copyright}</p>
      </div>
    </footer>
  );
};

export default Footer;
